angular.module('siter.io').factory 'Modal', ["$modal", "$rootScope", ($modal, $rootScope) ->

  # Modals

  modals =
    createLink: (parentId = false, widget) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/modules_settings/navigationfields/link.create.modal.jade"
        size: "md"
        controller: "LinkCreateModal"
        resolve:
          parentId: ->
            parentId
          widget: ->
            widget
      )
    editLink: (link, data) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/modules_settings/navigationfields/link.update.modal.jade"
        size: "md"
        controller: "LinkUpdateModal"
        resolve:
          link: ->
            link
          widget: ->
            data
      )

    newTemplate: ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./site/new_template.jade"
        controller: "NewTemplateController"
        size: "lg"
      )

    editTemplate: (template, mainTemplate) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./site/edit_template.jade"
        controller: "EditTemplateController"
        size: "lg"
        resolve:
          template: ->
            template
          mainTemplate: ->
            mainTemplate
      )
      modalInstance.result.then ->
        log ""
      , ->
        if Array.isArray(template.tags)
          template.tags = _.map template.tags, (tag) ->  tag.text
          template.tags = template.tags.join(",")
          template.colors = _.map template.colors, (tag, index) -> tag.text

    newEmailTemplate: ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./email/new_email.jade"
        controller: "NewEmailTemplateController"
        size: "lg"
      )

    editEmailTemplate: (template, mainTemplate) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./email/edit_email.jade"
        controller: "EditEmailTemplateController"
        size: "lg"
        resolve:
          template: ->
            template
          mainTemplate: ->
            mainTemplate
      )
      modalInstance.result.then ->
        log ""
      , ->
        if Array.isArray(template.tags)
          template.tags = _.map template.tags, (tag) ->  tag.text
          template.tags = template.tags.join(",")
          template.colors = _.map template.colors, (tag, index) -> tag.text

    newWebFormTemplate: ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./webform/new_webform.jade"
        controller: "NewWebFormTemplateController"
        size: "lg"
      )

    editWebFormTemplate: (template, mainTemplate) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./webform/edit_webform.jade"
        controller: "EditWebFormTemplateController"
        size: "lg"
        resolve:
          template: ->
            template
          mainTemplate: ->
            mainTemplate
      )
      modalInstance.result.then ->
        log ""
      , ->
        if Array.isArray(template.tags)
          template.tags = _.map template.tags, (tag) ->  tag.text
          template.tags = template.tags.join(",")
          template.colors = _.map template.colors, (tag, index) -> tag.text

    newLessonTemplate: ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./lesson/newLesson.jade"
        controller: "NewLessonTemplateController"
        size: "lg"
      )

    editLessonTemplate: (template, mainTemplate) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./lesson/editLesson.jade"
        controller: "EditLessonTemplateController"
        size: "lg"
        resolve:
          template: ->
            template
          mainTemplate: ->
            mainTemplate
      )
      modalInstance.result.then ->
        log ""
      , ->
        if Array.isArray(template.tags)
          template.tags = _.map template.tags, (tag) ->  tag.text
          template.tags = template.tags.join(",")
          template.colors = _.map template.colors, (tag, index) -> tag.text

    newLessonSectionModal: (allLessonSections) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./lesson/newLessonSection.jade"
        size: "md"
        controller: "NewLessonSectionModal"
        resolve:
          allLessonSections: ->
            allLessonSections
      )

    siteSettings: (link, data) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./site/site_settings/site_settings.jade"
        windowClass: "site-settings__modal"
        size: "md"
        controller: "SiteSettingsModal"
      )

    favoriteSettings: ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./site/favorite/favorite.jade"
        windowClass: "site-settings__modal"
        size: "md"
        controller: "SiteSettingsModal"
      )

    favoriteSectionSettings: (section) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/section_settings/create_favorite.jade"
        windowClass: "site-settings__modal"
        size: "md"
        controller: "CreateFavoriteSectionModal"
        resolve:
          section: ->
            section
      )

    createSectionModal: (allSections) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/section_settings/create.jade"
        size: "md"
        controller: "CreateSectionModal"
        resolve:
          allSections: ->
            allSections
      )


    editSectionModal: (section) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/section_settings/edit.jade"
        size: "md"
        controller: "EditSectionModal"
        resolve:
          section: ->
            section
      )
      modalInstance.result.then ->
        log ""
      , ->
        if Array.isArray(section.tags)
          section.tags = _.map section.tags, (tag) ->  tag.text
          section.tags = section.tags.join(",")
          section.colors = _.map section.colors, (tag, index) -> tag.text


    createEmailSectionModal: (allEmailSections) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/email_section_settings/create.jade"
        size: "md"
        controller: "CreateEmailSectionModal"
        resolve:
          allEmailSections: ->
            allEmailSections
      )


    editEmailSectionModal: (section) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./editor/email_section_settings/edit.jade"
        size: "md"
        controller: "EditEmailSectionModal"
        resolve:
          section: ->
            section
      )
      modalInstance.result.then ->
        log ""
      , ->
        if Array.isArray(section.tags)
          section.tags = _.map section.tags, (tag) ->  tag.text
          section.tags = section.tags.join(",")
          section.colors = _.map section.colors, (tag, index) -> tag.text
    newImage: ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./dashboard/images/new_image.jade"
        size: "md"
        controller: "NewImageCtrl"
      )

    editImage: (image) ->
      modalInstance = $modal.open(
        windowTemplateUrl: "./common/templates/window.jade"
        templateUrl: "./dashboard/images/edit_image.jade"
        size: "md"
        controller: "EditImageCtrl"
        resolve:
          image: ->
            image
      )
      modalInstance.result.then ->
        return
      , ->
        if Array.isArray(image.tag) and image.tag.length > 0
          image.tag = image.tag[0].text
  modals
]



// WEBPACK FOOTER //
// ./src/app/common/services/modals.service.coffee